import { render, staticRenderFns } from "./introduction.vue?vue&type=template&id=42fb1920&scoped=true&"
import script from "./introduction.vue?vue&type=script&lang=js&"
export * from "./introduction.vue?vue&type=script&lang=js&"
import style0 from "./introduction.vue?vue&type=style&index=0&id=42fb1920&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fb1920",
  null
  
)

export default component.exports